// extracted by mini-css-extract-plugin
export default {"footer":"SocialLinks_footer__Uoqte"};